module.exports = __webpack_public_path__ + "static/Features1-1e6155baf7141b41e34be21eedad38f2.jpg";